"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HttpStatusCodes = exports.FetchResult = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
let HttpStatusCodes = exports.HttpStatusCodes = /*#__PURE__*/function (HttpStatusCodes) {
  HttpStatusCodes[HttpStatusCodes["OK"] = 200] = "OK";
  HttpStatusCodes[HttpStatusCodes["NotFound"] = 404] = "NotFound";
  HttpStatusCodes[HttpStatusCodes["Forbidden"] = 403] = "Forbidden";
  HttpStatusCodes[HttpStatusCodes["InternalServerError"] = 500] = "InternalServerError";
  return HttpStatusCodes;
}({});
class FetchResult {
  constructor(httpStatus, response) {
    (0, _defineProperty2.default)(this, "httpStatus", void 0);
    (0, _defineProperty2.default)(this, "response", void 0);
    this.httpStatus = httpStatus;
    this.response = response;
  }
  isSuccess() {
    return FetchResult.isSuccess(this.httpStatus);
  }
  static get error() {
    return new FetchResult(HttpStatusCodes.InternalServerError, {
      errors: []
    });
  }
  static get errorFor() {
    return response => new FetchResult(HttpStatusCodes.InternalServerError, response);
  }
  static isSuccess(...httpStatuses) {
    const minSuccessCode = 200;
    const maxSuccessCode = 299;
    return httpStatuses.every(status => status >= minSuccessCode && status <= maxSuccessCode);
  }
  static isAllSuccess(...results) {
    return results.every(r => r === undefined || r.isSuccess());
  }
}
exports.FetchResult = FetchResult;